import $ from 'jquery';
import globalNav from '@99designs/common/apps/global-nav';

import 'app/modules/datetime';
import 'app/lib/transition-end';
import '@99designs/common/jquery-plugins/media-query-label';
import '@99designs/common/jquery-plugins/modal';
import '@99designs/common/jquery-plugins/tooltip';

// Fix https://www.cve.mitre.org/cgi-bin/cvename.cgi?name=2015-9251
// More: https://github.com/jquery/jquery/issues/2432
// Can be removed when on jQuery 3
jQuery.ajaxPrefilter((s) => {
    s.contents.script = false;
});

// Initialise asimov-media-query-label outside dom ready check below. It has its own check and we want
// this to fire early on.
$(document).mediaQueryLabel();

$(function () {
    // activate relative date stamps
    $('span.gmttime').dateTime();

    $(document).on('uiNeedsTimeUpdate', function (e, data) {
        $('span.gmttime').dateTime(true);
    });

    // update relative time every minute to provide a countdown
    setInterval(function () {
        $(document).trigger('uiNeedsTimeUpdate');
    }, 60000);

    globalNav();

    // activate asimov modals
    $('[data-modal-name]').modal();

    // activate asimov tooltips
    $('[data-tooltip]').tooltip();

    // automatically add CSRF tokens to ajax calls
    var token = $('meta[name="csrf-token"]').attr('content');

    $(document).ajaxSend(function (elm, xhr, s) {
        if (token && s && (s.type === 'POST' || s.type === 'DELETE' || s.type === 'PUT')) {
            xhr.setRequestHeader('X-Csrf-Token', token);
        }
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/layout.js